module.exports = __webpack_public_path__ + "static/media/no.0945bcf7.svg";